import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=631e326c&scoped=true&"
import script from "./SelectCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectCompany.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCompany.vue?vue&type=style&index=0&id=631e326c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e326c",
  null
  
)

export default component.exports